import SymptomsIllustrations from 'gatsby-theme-nurofen/src/components/SymptomsIllustrations/SymptomsIllustrations'

import './SymptomsIllustrationsOverride.scss'

export default SymptomsIllustrations
